import { isUndefined, isNull } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import core from '@gin-betting/core';

import { State } from 'types';
import { BettingWidgets } from 'app-constants';
import { useWidgetSettings, useMount } from 'hooks';
import ui from 'modules/ui';

const {
    viewport: {
        selectors: { makeViewportSelector },
    },
    utils: { getBettingOptions },
} = core;

const {
    actions: { toggleSidebar },
} = ui;

type Output = {
    parentNode: HTMLElement | null;
    canToggle?: boolean;
    isLarge: boolean;
    isAuthorized: boolean;
    ignoreOffsetInTheaterMode: boolean;
} | null;

const selectIsLarge = makeViewportSelector('lessThanOrEqual', 'large');

function useBetslipSidebarWrapper(): Output {
    const dispatch = useDispatch();
    const { isAuthorized } = getBettingOptions();
    const isLarge = useSelector((s: State) => selectIsLarge(s, {}));
    const { isOpen, containerElementId, canToggle } = useWidgetSettings({
        widget: BettingWidgets.BETSLIP_SIDEBAR,
    });

    const { ignoreOffsetInTheaterMode } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    useMount(() => {
        if (isUndefined(isOpen)) return;

        dispatch(toggleSidebar({ isOpen }));
    });

    if (isNull(containerElementId)) return null;

    const parentNode = containerElementId
        ? document.getElementById(containerElementId)
        : null;

    return {
        parentNode,
        canToggle,
        isLarge,
        isAuthorized,
        ignoreOffsetInTheaterMode: Boolean(ignoreOffsetInTheaterMode),
    };
}

export default useBetslipSidebarWrapper;
